import React from 'react';
import {
	Modal,
	Button,
	Col,
	Row,
	Well
} from 'react-bootstrap';
import Dropzone from 'react-dropzone';
import csvParser from 'papaparse';
import { findIndex } from 'lodash';

import custJqAjax from '../../../commonJS/custJqAjax';

const ReadyForBatchUploadMsg = (props) => (
	<div style={{ marginLeft: 10 }}>
		<h5 style={{ color: 'blue' }}>資料讀取完成 ( 尚未上傳 )。</h5>
		<h5>已讀取 <span style={{ color: 'blue' }}>{props.dataAmountPart}</span> 筆資料。</h5>
		<h5>資料內容初步檢查<span style={{ color: 'blue' }}>無未填</span>亦<span style={{ color: 'blue' }}>無序號重複</span>問題。</h5>
		<h5>請確認下方括弧內的文字，若為亂碼請確認 csv 檔案編碼方式為 utf-8 並重新讀取檔案。</h5>
		<h5>若為中文代表編碼正常，請點擊儲存鈕將資料上傳至資料庫。</h5>
		<h5>( <span style={{ color: 'blue' }}>{props.encodeCheck}</span> )</h5>
		{/* <p>資料總筆數 <span style={{color: 'blue'}}>{props.dataAmountRecord + props.dataAmountPart}</span> </p>
    <p>出貨紀錄筆數 <span style={{color: 'blue'}}>{props.dataAmountRecord}</span> </p>
    <p>出貨明細筆數 <span style={{color: 'blue'}}>{props.dataAmountPart}</span> </p> */}
	</div>
);

const ErrorForBatchUploadMsg = (props) => (
	<div style={{ marginLeft: 10 }}>
		<h5 style={{ color: 'red' }}>資料異常，請修正後重新讀取。</h5>
		{
			props.errorRows.map((item, ind) => {
				switch (item.errorType) {
					case 'recordSerialDuplicate':
					case 'partSerialDuplicate':
						return (
							<p key={ind}>
								第 <span style={{ color: 'red' }}>{item.sequence + 1}</span> 列資料與第 <span style={{ color: 'red' }}>{item.duplicateSquence + 1}</span> 列資料<span style={{ color: 'red' }}>序號</span>重複。
							</p>
						);
					case 'empty':
						return (
							<p key={ind}>
								第 <span style={{ color: 'red' }}>{item.sequence + 1}</span> 列資料必填欄位
								<span style={{ color: 'red' }}>
									{
										item.missingFieldsInd.map((item1, ind1) => {

											return (
												ind1 === (item.missingFieldsInd.length - 1)
													? (props.requirementFields[item1])
													: (props.requirementFields[item1] + '、')
											)
										})
									}
								</span>
								{props.emptyMessage}
							</p>
						);
					default:
						return '';
				}
			})
		}
	</div>
);

const UploadResultMsg = (props) => (
	<div style={{ marginLeft: 10 }}>
		<h5 style={{ color: 'blue' }}>資料已上傳完成。</h5>
		<h5>成功 <span style={{ color: 'blue' }}>{props.successAmount}</span> 筆。</h5>
		<h5>失敗 <span style={{ color: 'red' }}>{props.failureAmount}</span> 筆。</h5>
	</div>
);




export default class BatchUploadModalCt extends React.Component {
	constructor(props) {
		super(props);

		this.acceptFormats = 'text/csv';

		this.handlers = {
			onDrop: (accpetedFiles, rejectedFiles) => {
				// 清除上傳結果與資料
				this.setState({
					uploadResult: {},
					verifiedRows: [],
					errorRows: []
				});

				// 因為windows平台對某些檔案傳回的type值為空白，例如csv
				// 此處特別處理
				if (rejectedFiles.length && !rejectedFiles[0].type) {
					// 搭配上傳介面文字提示只接受csv檔案
					accpetedFiles = rejectedFiles;
				}

				if (accpetedFiles.length) {
					// 讀取detail
					accpetedFiles.forEach((file) => {
						const reader = new FileReader();
						// set reader event handlers
						reader.onload = () => {
							const fileAsText = reader.result,
								rows = csvParser.parse(fileAsText).data,
								serialNumberCollection = [],
								errorRows = [],
								encodeCheck = rows[0][0] + rows[0][1] + rows[0][2];

							let dataAmountRecord = 0, dataAmountPart = 0;

							// 產生序號重複檢查資料結構，主紀錄帶明細同一列兩筆
							for (let i = 2, len = rows.length; i < len; i++) {
								if (rows[i][1] || rows[i][1] === 0) {
									serialNumberCollection.push({
										sequence: i,
										type: 'record',
										serialNumber: rows[i][1]
									});
								}

								if (rows[i][11] || rows[i][11] === 0) {
									serialNumberCollection.push({
										sequence: i,
										type: 'part',
										serialNumber: rows[i][11]
									});
								}
							}
							// 序號排序
							this.funcs.sortingArrCollections(serialNumberCollection, 'serialNumber');

							// 異常檢查
							for (let i = 2, len = rows.length; i < len; i++) {
								// 判斷類別
								// record row with part
								if (
									rows[i][0] || rows[i][0] === 0 ||
									rows[i][1] || rows[i][1] === 0 ||
									rows[i][2] || rows[i][2] === 0
								) {

									dataAmountRecord++;
									dataAmountPart++;

									// 未填檢查
									const missingFieldsInd = [];
									if (!rows[i][0] && rows[i][0] !== 0) missingFieldsInd.push(0);
									if (!rows[i][1] && rows[i][1] !== 0) missingFieldsInd.push(1);
									if (!rows[i][2] && rows[i][2] !== 0) missingFieldsInd.push(2);
									if (!rows[i][8] && rows[i][8] !== 0) missingFieldsInd.push(3);
									if (!rows[i][9] && rows[i][9] !== 0) missingFieldsInd.push(4);
									if (!rows[i][14] && rows[i][14] !== 0) missingFieldsInd.push(5);

									if (missingFieldsInd.length) {
										errorRows.push({
											sequence: i,
											errorType: 'empty',
											missingFieldsInd
										});
									}
									// 重複檢查
									// 取得 record 位置
									// 其實上下比一個即可，因為重複必定是一對，一定有一個在上，
									// 減少比對，以及多餘資訊
									let orinInd = findIndex(serialNumberCollection, { sequence: i, type: 'record' });

									if (orinInd !== -1) {
										// 與下一筆相同則代表有重複
										if (serialNumberCollection[orinInd + 1] && serialNumberCollection[orinInd]['serialNumber'] === serialNumberCollection[orinInd + 1]['serialNumber']) {
											errorRows.push({
												sequence: i,
												errorType: 'recordSerialDuplicate',
												duplicateSquence: serialNumberCollection[orinInd + 1]['sequence']
											});
										}
									}
									// 取得 part in record 位置
									orinInd = findIndex(serialNumberCollection, { sequence: i, type: 'part' });
									if (orinInd !== -1) {
										// 與下一筆相同則代表有重複
										if (serialNumberCollection[orinInd + 1] && serialNumberCollection[orinInd]['serialNumber'] === serialNumberCollection[orinInd + 1]['serialNumber']) {
											errorRows.push({
												sequence: i,
												errorType: 'partSerialDuplicate',
												duplicateSquence: serialNumberCollection[orinInd + 1]['sequence']
											});
										}
									}
									// part row
								} else if (
									rows[i][8] || rows[i][8] === 0 ||
									rows[i][9] || rows[i][9] === 0 ||
									rows[i][14] || rows[i][14] === 0
								) {

									dataAmountPart++;

									// 未填檢查
									const missingFieldsInd = [];
									if (!rows[i][8] && rows[i][8] !== 0) missingFieldsInd.push(3);
									if (!rows[i][9] && rows[i][9] !== 0) missingFieldsInd.push(4);
									if (!rows[i][14] && rows[i][14] !== 0) missingFieldsInd.push(5);

									if (missingFieldsInd.length) {
										errorRows.push({
											sequence: i,
											errorType: 'empty',
											missingFieldsInd
										});
									}
									// 重複檢查
									// 取得 part 位置
									const orinInd = findIndex(serialNumberCollection, { sequence: i, type: 'part' });
									if (orinInd !== -1) {
										// 與下一筆相同則代表有重複
										if (serialNumberCollection[orinInd + 1] && serialNumberCollection[orinInd]['serialNumber'] === serialNumberCollection[orinInd + 1]['serialNumber']) {
											errorRows.push({
												sequence: i,
												errorType: 'partSerialDuplicate',
												duplicateSquence: serialNumberCollection[orinInd + 1]['sequence']
											});
										}
									}
									// 必填皆未填，太離譜就不檢查是否重複了
								} else {
									errorRows.push({
										sequence: i,
										errorType: 'empty',
										missingFieldsInd: [0, 1, 2, 3, 4, 5]
									});
								}
							}

							// ===

							// 無錯誤才可上傳
							if (errorRows.length) {
								this.setState({ errorRows, verifiedRows: [] });
							} else {
								const verifiedRows = rows.splice(2);
								this.setState({ verifiedRows, dataAmountRecord, dataAmountPart, encodeCheck, errorRows: [] });
							}

						}

						reader.onabort = () => { }

						reader.onerror = () => { }
						// start reading, file must be encoded with utf-8
						reader.readAsText(file);

					});

				} else if (rejectedFiles.length) { }

			},
			onCloseClick: () => {
				this.props.parentStateHandler({ states: 'showBatchUploadModal', newValues: false });
			},
			saveItem: () => {
				this.setState({
					onDataUpload: true
				});


				const state = this.state,
					formData = new FormData();

				let skyChainDataList = '';

				for (let i = 0, len = state.verifiedRows.length; i < len; i++) {
					for (let i1 = 0, len1 = state.verifiedRows[i].length; i1 < len1; i1++) {
						if (i1 === (len1 - 1)) {
							if (i === (len - 1)) {
								skyChainDataList += state.verifiedRows[i][i1];
							} else {
								skyChainDataList += state.verifiedRows[i][i1] + '|';
							}
						} else {
							skyChainDataList += state.verifiedRows[i][i1] + '∞';
						}
					}
				}

				formData.append('skychain_data_list', skyChainDataList);

				custJqAjax({
					type: 'POST',
					url: '/api/W_Import_SkyChain_Data_Post.php',
					data: formData,
					processData: false,
					contentType: false,
					success: res => {
						if (res.status === '0') {
							this.setState({
								uploadResult: {
									successAmount: res.result[0].ok_count,
									failureAmount: res.result[0].err_count
								},
								onDataUpload: false,
								verifiedRows: []
							});
						}
					}
				});
			}
		};

		this.consts = {
			emptyMessage: '未填寫。',
			requirementFields: [
				'機型',
				'序號',
				'出貨日期',
				'料號',
				'品名(中文)',
				'聯絡人_id'
			]
		};

		this.funcs = {
			sortingArrCollections: (arrColl, sortInd) => {

				arrColl.sort((itemA, itemB) => {

					const valueA = itemA[sortInd];
					const valueB = itemB[sortInd];
					let sortVal = 0;
					if (valueA > valueB) {
						sortVal = 1;
					}
					if (valueA < valueB) {
						sortVal = -1;
					}
					// 預設遞增，以下做遞減反轉
					// if (sortVal !== 0 && sortDir === SortTypes.ASC) {
					//   sortVal *= -1;
					// }

					return sortVal;
				});
			}
		};

		this.state = {
			verifiedRows: [],
			errorRows: [],
			dataAmountRecord: 0,
			dataAmountPart: 0,
			encodeCheck: '',
			uploadResult: {},
			onDataUpload: false,
			// common ===
			btnSaveDisable: true
			// ===
		};
	}

	componentDidUpdate(prevProps, prevState) {
		// 資料驗證ok才可送出
		if (!this.state.verifiedRows.length) {
			if (!this.state.btnSaveDisable) this.setState({ btnSaveDisable: true });
		} else if (this.state.btnSaveDisable) {
			this.setState({ btnSaveDisable: false });
		}
	}

	render() {
		const state = this.state,
			handlers = this.handlers;

		const saveBtn = (
			<Button disabled={state.onDataUpload || state.btnSaveDisable}
				onClick={() => { handlers.saveItem() }}
				style={{ float: 'right', marginLeft: 5, position: 'relative', zIndex: '3' }}>
				{state.onDataUpload ? '資料上傳中，請稍候…' : '儲存'}
			</Button>
		),
			cancelBtn = (
				<Button
					onClick={handlers.onCloseClick}
					style={{ float: 'right', marginLeft: 5, position: 'relative', zIndex: '3' }}>
					關閉
				</Button>
			);

		let dropAreaMessage;

		if (state.uploadResult.successAmount || state.uploadResult.successAmount === '0') {
			dropAreaMessage = (
				<UploadResultMsg
					successAmount={state.uploadResult.successAmount}
					failureAmount={state.uploadResult.failureAmount} />
			);
		} else if (state.verifiedRows.length) {
			dropAreaMessage = (
				<ReadyForBatchUploadMsg
					dataAmountRecord={state.dataAmountRecord}
					dataAmountPart={state.dataAmountPart}
					encodeCheck={state.encodeCheck} />
			);
		} else if (state.errorRows.length) {
			dropAreaMessage = (
				<ErrorForBatchUploadMsg
					errorRows={state.errorRows}
					requirementFields={this.consts.requirementFields}
					emptyMessage={this.consts.emptyMessage} />
			);
		} else {
			dropAreaMessage = (
				<div className='div-file-drop-zone-placeholder'>
					請拖拉檔案至此區域，或點擊後選擇檔案。
				</div>
			);
		}

		return (
			<Modal id='modal-product' keyboard={false} backdrop='static' show={true} onHide={null} bsSize='large'>
				<Modal.Header>
					<Modal.Title>
						<span style={{ padding: '6px 0px', height: 34, lineHeight: '34px' }}>
							<span>
								批次上傳 (僅限 csv 檔案)
							</span>
						</span>
						{cancelBtn}
						{saveBtn}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<Row>
						<Col sm={12}>
							<Well style={{ margin: 0 }}>
								<Dropzone
									onDrop={state.onDataUpload ? null : handlers.onDrop}
									multiple={false}
									className='cust-file-dropzone'
									activeClassName='cust-file-dropzone-active'
									accept={this.acceptFormats}
									disableClick={state.onDataUpload}
									preventDropOnDocument={true}
									disablePreview={false}>
									<div style={{ maxHeight: 900, overflow: 'auto' }}>
										{dropAreaMessage}
									</div>
								</Dropzone>
							</Well>
						</Col>

						<Col sm={12}>

						</Col>

					</Row>
				</Modal.Body>
				<Modal.Footer>
					{cancelBtn}
					{saveBtn}
				</Modal.Footer>
			</Modal>
		);
	}
}


// WEBPACK FOOTER //
// ./src/salesky/routes/dashboard/BatchUploadModalCt.jsx